import { DefaultOptions, QueryClient, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 30000,
    gcTime: 30000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    networkMode: 'always',
    retry: true,
    retryDelay: (attemptIndex) => Math.min(1000 * attemptIndex, 10000),
    throwOnError: false
    // onError: (err) => {
    //   console.log('RECIEVED AN ERROR RQ')
    // }
  },
  mutations: {
    throwOnError: false,
    retry: false,
    retryDelay: (attemptIndex) => Math.min(1000 * attemptIndex, 10000)
  }
}

export const queryClient = new QueryClient({ defaultOptions: queryConfig })

// queryClient.setQueryData(QUERY_KEY_MANAGEMENT_SEARCH_UNITS(), (existingData: any) =>
//   existingData
//     ? {
//         pageParams: [existingData.pageParams[0]],
//         pages: [existingData.pages[0]]
//       }
//     : undefined
// )

// queryClient.setQueryData(QUERY_SEARCH_UNITS(), (existingData: any) =>
//   existingData
//     ? {
//         pageParams: [existingData.pageParams[0]],
//         pages: [existingData.pages[0]]
//       }
//     : undefined
// )
// eslint-disable-next-line no-undef
export type ExtractFnReturnType<FnType extends (...args: any) => any> = Awaited<ReturnType<FnType>>

export type QueryConfig<QueryFnType extends (...args: any) => any> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  'queryKey' | 'queryFn' | 'initialData'
>

export type MutationConfig<MutationFnType extends (...args: any) => any> = UseMutationOptions<
  ExtractFnReturnType<MutationFnType>,
  AxiosError,
  Parameters<MutationFnType>[0]
>
